import {PhoneOutlined} from '@ant-design/icons'
import Commonview from '../../../pages/common_view';
import ANumberManage from "../../../pages/number_pool_manage/a_pool_manage/a_number_manage";
import PoolAAllocation from "../../../pages/number_pool_manage/a_pool_manage/pool_a_allocation";
import PoolXAllocation from '../../../pages/number_pool_manage/x_pool_manage/pool_x_allocation';
import XNumberManage from "../../../pages/number_pool_manage/x_pool_manage/x_number_manage";
import MyApplication from "../../../pages/number_pool_manage/x_pool_manage/my_application";


const NumberPoolRouter = [
    {
        path: '/numberPoolManage',
        element: <Commonview/>,
        meta: {title: '号池管理', icon: <PhoneOutlined />},
        children: [
            {
                path: '/numberPoolManage/APoolManage',
                meta: {title: 'A池'},
                children: [
                    {
                        path: '/numberPoolManage/APoolManage/ANumberPoolManage',
                        meta: {title: 'A池管理', key: 'apool_management'},
                        element: <PoolAAllocation/>,
                    },
                    {
                        path: '/numberPoolManage/APoolManage/ANumberManage',
                        meta: {title: '号码管理', key: 'apool_number_management'},
                        element: <ANumberManage/>,
                    }
                ]
            },
            {
                path: '/numberPoolManage/XPoolManage',
                meta: {title: 'X池'},
                children: [
                    {
                        path: '/numberPoolManage/XPoolManage/XNumberPoolManage',
                        meta: {title: 'X池管理', key: 'xpool_management'},
                        element: <PoolXAllocation/>,
                    },
                    {
                        path: '/numberPoolManage/XPoolManage/XNumberManage',
                        meta: {title: '号码管理', key: 'xpool_number_management'},
                        element: <XNumberManage/>,
                    },
                    {
                        path: '/numberPoolManage/XPoolManage/myApplication',
                        meta: {title: '我的申请', key: 'xpool_apply_management'},
                        element: <MyApplication/>,
                    }
                ]
            },
        ]
    }
]

export default NumberPoolRouter
